module.exports = __webpack_public_path__ + "img/Google.64df68ea.png";